var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMandiri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 93.094002,
    viewBox: "0 0 200 93.094002",
    id: "svg25423",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs25427"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30024",
    transform: "matrix(15.202977,0,0,15.202977,-784.18639,-625.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25375",
    transform: "matrix(0.13159298,0,0,0.13159298,46.045058,18.836552)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "20.7605px",
      fontFamily: "Laksaman",
      InkscapeFontSpecification: "'Laksaman, Normal'",
      fill: "#e55a02",
      fillOpacity: 1,
      strokeWidth: 0.519013
    },
    d: "m 43.591617,215.5931 h -1.198178 v -11.02876 h 1.198178 z",
    id: "path10837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.293789,215.5931 h -1.198178 v -6.25898 q 0,-3.92805 -3.035385,-3.92805 -1.198178,0 -2.17669,1.10072 -0.978512,1.10071 -0.978512,2.39567 v 6.69064 h -1.198178 v -8.30934 q 0,-0.97122 -0.199697,-2.71942 h 1.1183 q 0.199696,0.66907 0.239636,1.96403 1.158239,-2.20143 3.434777,-2.20143 3.993927,0 3.993927,5.00718 z",
    id: "path10839",
    style: {
      fontSize: "20.7605px",
      fontFamily: "Laksaman",
      InkscapeFontSpecification: "'Laksaman, Normal'",
      fill: "#e55a02",
      fillOpacity: 1,
      strokeWidth: 0.519013
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 66.995967,209.33412 v 6.25898 h -1.198178 v -6.25898 q 0,-3.92805 -3.035385,-3.92805 -1.198178,0 -2.17669,1.10072 -0.978513,1.10071 -0.978513,2.39567 v 6.69064 h -1.198178 v -16.40284 h 1.198178 v 7.33811 q 1.238118,-2.20143 3.394838,-2.20143 3.993928,0 3.993928,5.00718 z",
    id: "path10841",
    style: {
      fontSize: "20.7605px",
      fontFamily: "Laksaman",
      InkscapeFontSpecification: "'Laksaman, Normal'",
      fill: "#072d5c",
      fillOpacity: 1,
      strokeWidth: 0.519013
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 70.570502,210.17584 q 0.05991,2.09352 1.158239,3.3669 1.1183,1.27338 2.975477,1.27338 1.737358,0 3.574564,-0.77698 l 0.09985,1.05756 q -1.777298,0.79855 -3.794231,0.79855 -2.296509,0 -3.754292,-1.53236 -1.457784,-1.55396 -1.457784,-3.9928 0,-2.6115 1.397875,-4.31654 1.417844,-1.72661 3.694383,-1.72661 4.293471,0 4.39332,5.8489 z m 7.089222,-1.07913 q -0.03994,-1.68345 -0.958543,-2.67626 -0.898634,-1.01438 -2.376387,-1.01438 -1.477753,0 -2.476235,1.05756 -0.998482,1.03596 -1.218147,2.63308 z",
    id: "path10843",
    style: {
      fontSize: "20.7605px",
      fontFamily: "Laksaman",
      InkscapeFontSpecification: "'Laksaman, Normal'",
      fill: "#072d5c",
      fillOpacity: 1,
      strokeWidth: 0.519013
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 83.810338,215.89525 q -1.357935,0 -2.316478,-0.84173 -0.938573,-0.8633 -0.938573,-2.22301 0,-4.12229 6.789676,-4.12229 0,-1.57554 -0.698936,-2.43884 -0.698938,-0.86331 -2.056873,-0.86331 -1.09833,0 -3.255051,0.73381 l -0.139788,-1.23021 q 1.67745,-0.58273 3.474717,-0.58273 3.87411,0 3.87411,4.61869 v 3.94963 q 0,1.35971 0.359453,2.69784 l -1.038421,0.2374 -0.419362,-1.79136 q -1.377905,1.85611 -3.634474,1.85611 z m -2.056873,-3.28056 q 0,1.01438 0.57912,1.6187 0.579119,0.58273 1.517693,0.58273 1.198178,0 2.336447,-0.79856 1.158238,-0.82014 1.158238,-1.98561 v -2.2446 q -5.591498,0 -5.591498,2.82734 z",
    id: "path10845",
    style: {
      fontSize: "20.7605px",
      fontFamily: "Laksaman",
      InkscapeFontSpecification: "'Laksaman, Normal'",
      fill: "#072d5c",
      fillOpacity: 1,
      strokeWidth: 0.519013
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 98.434674,215.89525 q -1.23812,0 -1.937058,-0.9928 -0.678968,-1.01438 -0.678968,-2.54676 v -6.82013 h -2.036903 v -0.97122 h 2.036903 v -3.28056 l 1.198179,-0.58274 v 3.8633 h 3.255053 v 0.97122 h -3.255053 v 6.82013 q 0,2.46043 1.517697,2.46043 0.93857,0 1.3779,-0.19425 l 0.119816,0.97123 q -0.619056,0.30215 -1.597566,0.30215 z",
    id: "path10849",
    style: {
      fontSize: "20.7605px",
      fontFamily: "Laksaman",
      InkscapeFontSpecification: "'Laksaman, Normal'",
      fill: "#072d5c",
      fillOpacity: 1,
      strokeWidth: 0.519013
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 110.73843,209.33412 v 6.25898 h -1.19818 v -6.25898 q 0,-3.92805 -3.03539,-3.92805 -1.19818,0 -2.17668,1.10072 -0.97852,1.10071 -0.97852,2.39567 v 6.69064 h -1.19818 v -16.40284 h 1.19818 v 7.33811 q 1.23811,-2.20143 3.39484,-2.20143 3.99393,0 3.99393,5.00718 z",
    id: "path10851",
    style: {
      fontSize: "20.7605px",
      fontFamily: "Laksaman",
      InkscapeFontSpecification: "'Laksaman, Normal'",
      fill: "#072d5c",
      fillOpacity: 1,
      strokeWidth: 0.519013
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#072d5c",
      fillOpacity: 1,
      strokeWidth: 1.63344,
      InkscapeStroke: "none",
      stopColor: "#000000"
    },
    id: "rect12404",
    width: 1.1978494,
    height: 16.601528,
    x: 91.658371,
    y: 199.19026
  })), /*#__PURE__*/React.createElement("g", {
    id: "g25860",
    transform: "matrix(0.15117927,0,0,0.15117927,50.599954,39.267295)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0d2b5b",
    d: "m 6.58,29.745 c 0,-1.259 -0.022,-2.313 -0.09,-3.256 h 2.381 l 0.113,1.618 H 9.05 c 0.539,-0.854 1.527,-1.866 3.369,-1.866 1.438,0 2.56,0.81 3.032,2.022 h 0.046 c 0.382,-0.606 0.83,-1.056 1.346,-1.369 0.607,-0.428 1.305,-0.653 2.202,-0.653 1.82,0 3.66,1.235 3.66,4.741 v 6.444 H 20.01 v -6.042 c 0,-1.818 -0.629,-2.898 -1.954,-2.898 -0.943,0 -1.64,0.676 -1.931,1.462 a 3.951,3.951 0 0 0 -0.135,0.919 v 6.56 h -2.695 v -6.336 c 0,-1.524 -0.606,-2.604 -1.887,-2.604 -1.031,0 -1.727,0.81 -1.977,1.572 -0.111,0.27 -0.157,0.586 -0.157,0.898 v 6.47 H 6.58 Z M 33.206,34.8 c 0,0.987 0.045,1.952 0.156,2.627 H 30.869 L 30.69,36.215 h -0.068 c -0.674,0.854 -1.82,1.458 -3.232,1.458 -2.202,0 -3.437,-1.593 -3.437,-3.256 0,-2.765 2.446,-4.155 6.491,-4.133 v -0.179 c 0,-0.72 -0.293,-1.91 -2.225,-1.91 -1.079,0 -2.201,0.338 -2.942,0.808 l -0.539,-1.797 c 0.809,-0.495 2.224,-0.966 3.952,-0.966 3.505,0 4.517,2.226 4.517,4.604 z M 30.51,32.083 c -1.955,-0.046 -3.818,0.381 -3.818,2.043 0,1.078 0.698,1.573 1.573,1.573 1.099,0 1.909,-0.721 2.156,-1.506 a 2.03,2.03 0 0 0 0.09,-0.606 v -1.504 z m 4.604,-2.338 c 0,-1.259 -0.023,-2.313 -0.088,-3.256 h 2.423 l 0.134,1.642 h 0.068 c 0.471,-0.855 1.662,-1.89 3.481,-1.89 1.91,0 3.885,1.235 3.885,4.696 v 6.489 h -2.762 v -6.175 c 0,-1.572 -0.585,-2.766 -2.089,-2.766 -1.099,0 -1.865,0.787 -2.156,1.619 -0.09,0.246 -0.112,0.584 -0.112,0.896 v 6.425 h -2.785 z m 21.881,-7.65 V 34.35 c 0,1.123 0.046,2.338 0.09,3.077 h -2.469 l -0.113,-1.728 h -0.046 c -0.65,1.212 -1.977,1.975 -3.57,1.975 -2.606,0 -4.671,-2.223 -4.671,-5.59 -0.024,-3.662 2.266,-5.842 4.896,-5.842 1.504,0 2.582,0.629 3.076,1.441 h 0.047 v -5.587 h 2.761 v -0.001 z m -2.761,8.953 c 0,-0.223 -0.022,-0.493 -0.068,-0.719 -0.247,-1.076 -1.121,-1.953 -2.38,-1.953 -1.774,0 -2.764,1.573 -2.764,3.616 0,1.997 0.989,3.458 2.742,3.458 1.121,0 2.11,-0.765 2.379,-1.955 0.068,-0.246 0.092,-0.517 0.092,-0.808 v -1.639 z m 4.715,6.379 V 26.489 h 2.787 v 10.938 z m 4.739,-7.411 c 0,-1.482 -0.021,-2.539 -0.088,-3.526 h 2.403 l 0.088,2.087 h 0.091 C 66.721,27.028 68,26.49 69.171,26.49 c 0.269,0 0.425,-0.046 0.649,0 v 2.427 a 3.812,3.812 0 0 0 -0.807,-0.09 c -1.328,0 -2.226,0.854 -2.472,2.087 a 4.962,4.962 0 0 0 -0.089,0.856 v 5.658 h -2.764 z m 7.414,7.411 V 26.489 h 2.783 v 10.938 z",
    id: "path25419"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fdd213",
    d: "m 91.221,14.871871 c -1.379,-1.573 -2.845,-0.861 -4.01,-0.282 -0.49,0.242 -4.027,2.247 -4.027,2.247 -1.938,0.799 -3.447,-0.073 -4.039,-0.807 a 1.738,1.738 0 0 1 -0.153,-0.221 l -0.138,-0.239 a 10.756,10.756 0 0 0 -0.776,-1.161 6.556,6.556 0 0 0 -0.558,-0.637 c -1.326,-1.339 -3.445,-2.276 -6.987,-0.574 -1.677,0.972 -7.14,4.093 -7.14,4.093 -2.053,0.845 -3.623,-0.184 -4.133,-0.939 a 0.549,0.549 0 0 1 -0.06,-0.091 l -0.067,-0.114 -0.346,-0.566 a 9.512,9.512 0 0 0 -0.502,-0.721 7.25,7.25 0 0 0 -0.559,-0.636 c -1.317,-1.331 -3.425,-2.266 -6.936,-0.596 -2.123,1.212 -7.061,4.035 -7.061,4.035 l -0.002,0.002 -3.614,2.065 1.87,2.296 c 0.787,0.75 2.266,1.98 4.554,0.943 0,0 6.315,-3.657 6.34,-3.668 5.399,-2.963 8.063,-0.132 9.241,1.755 0.041,0.059 0.074,0.123 0.111,0.18 l 0.002,0.003 c 0.015,0.023 0.024,0.044 0.037,0.066 l 0.133,0.218 c 0.574,0.87 1.479,1.432 2.558,1.406 0.595,-0.012 0.999,-0.206 1.587,-0.533 l 6.11,-3.544 0.013,-0.006 c 5.467,-2.999 8.176,0.017 9.333,1.904 0.09,0.163 0.192,0.319 0.297,0.464 0.573,0.777 1.363,1.286 2.367,1.261 0.663,-0.013 1.406,-0.411 1.517,-0.484 l 7.325,-4.228 c 0.002,0.002 -0.746,-1.129 -2.287,-2.891 z",
    id: "path25421",
    style: {
      fill: "#fea501",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandiri);
export default __webpack_public_path__ + "static/media/mandiri.64494f31f2922cf32a18521cd942af6f.svg";
export { ForwardRef as ReactComponent };